import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import FormTemplatesTab from '../settings/tabs/FormTemplatesTab';
import IntakeFormsTab from '../settings/tabs/IntakeFormsTab';
import SignedDocumentsList from '../documents/SignedDocumentsList';
import FormBuilderTab from './FormBuilderTab';
import { FileText, ClipboardList, FileCheck, PenLine } from 'lucide-react';

const TABS = [
  { key: 'templates', label: 'E-sign templates', Icon: FileText },
  { key: 'builder',   label: 'Form builder',     Icon: PenLine },
  { key: 'patient',   label: 'Patient forms',    Icon: ClipboardList },
  { key: 'completed', label: 'Completed',        Icon: FileCheck },
];

export default function FormsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(TABS.some(t => t.key === requested) ? requested : 'templates');

  const switchTab = (tab) => { setActiveTab(tab); setSearchParams({ tab }); };

  return (
    <div className="flex-1 bg-primary">
      <div className="max-w-[960px] mx-auto px-4 md:px-7 py-6">
        <h1 className="text-[22px] font-bold text-primary-c mb-1">Forms</h1>
        <p className="text-[12px] text-muted-c mb-6">
          Upload documents for e-signature, build your own questionnaires, and manage patient intake forms.
        </p>

        <div className="flex bg-tertiary rounded-[10px] p-1 mb-6 w-fit max-w-full overflow-x-auto">
          {TABS.map(t => (
            <button
              key={t.key}
              onClick={() => switchTab(t.key)}
              className={`px-3 sm:px-5 py-2.5 rounded-[7px] text-[13px] font-medium transition-all flex items-center gap-1.5 whitespace-nowrap ${
                activeTab === t.key
                  ? 'bg-accent text-white shadow-glow'
                  : 'text-muted-c hover:text-primary-c'
              }`}
            >
              <t.Icon size={14} strokeWidth={2.2} />
              <span className={activeTab === t.key ? '' : 'hidden sm:inline'}>{t.label}</span>
            </button>
          ))}
        </div>

        {activeTab === 'templates' && <FormTemplatesTab />}
        {activeTab === 'builder' && <FormBuilderTab />}
        {activeTab === 'patient' && <IntakeFormsTab />}
        {activeTab === 'completed' && <SignedDocumentsList />}
      </div>
    </div>
  );
}
